import { StyleSheet } from 'react-native';
export var getGridScrollListStyles = props => {
  var separatorSpace = props.separatorSpace,
    numberOfColumn = props.numberOfColumn;
  return StyleSheet.create({
    gridContainer: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      flexShrink: 1
    }, separatorSpace && {
      marginLeft: -separatorSpace,
      marginBottom: separatorSpace
    }),
    gridItem: {
      paddingLeft: separatorSpace,
      paddingBottom: separatorSpace,
      width: 100 / numberOfColumn + "%"
    }
  });
};